// extracted by mini-css-extract-plugin
export default {"cards":"plans_cards__ZAv-U","cards2":"plans_cards2__TjKwV","imgPreview":"plans_imgPreview__R6bsd"};